import createAssetFromClick from './createAssetFromClick';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { isCurrentCultureRightToLeft } from 'owa-localize';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import type * as React from 'react';

export default function getTimeStreamAssetMenuItem(
    assetDescriptor: AssetDescriptor
): IContextualMenuItem {
    const { type, getToolName, getTooltip, iconName, iconNameRTL } = assetDescriptor;

    const toolName = getToolName();
    const tooltip = getTooltip ? getTooltip() : toolName;
    const isRTL = isCurrentCultureRightToLeft();
    const actualIconName = (isRTL && iconNameRTL) || iconName;

    const onClick = (evt?: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => {
        if (evt) {
            createAssetFromClick(evt, assetDescriptor, 'Menu');
        }
    };

    return {
        key: type,
        text: toolName,
        title: tooltip,
        iconProps: {
            iconName: actualIconName,
        },
        onClick,
    };
}
